<template>
  <div class="vg-content">
    <van-image class="logo" width="100" height="50" :src="srcLogo"/>
    <van-image style="margin-top: 85px;" width="110" height="110" :src="srcInformation"/>
    <div class="text">请确认支付是否已完成</div>
    <vg-button type="primary" style="width: 300px; height: 44px; margin-top: 70px" @click="onSubmit">完成支付
    </vg-button>
    <vg-button type="default" style="width: 300px; height: 44px; margin-top: 30px" @click="onError">
      支付遇到问题，重新支付
    </vg-button>
  </div>

</template>

<script>
import {Image as VanImage} from "vant";
import srcLogo from "@/assets/login/kaidelogo.png";
import srcInformation from "@/assets/scanverify/information.svg";
import VgButton from "@/components/Commons/VgButton";
import {client} from "@/libraries/http";

export default {
  name: "ConfirmPay",
  components: {
    VanImage,
    VgButton,
  },
  data() {
    return {
      srcLogo: srcLogo,
      srcInformation: srcInformation,
      orderNo: "",
      orderAmount: "",
      payType: "",    //ALIPAY MWEB JSAPI
    }
  },
  created() {
    console.log(this.$route);
    this.orderNo = this.$route.query.orderNo;
    this.orderAmount = this.$route.query.orderAmount;
    this.payType = this.$route.query.payType;
    this.queryPay(true);
  },
  methods: {
    onSubmit() {
      this.queryPay(false);
    },
    onError() {
      this.queryPay(false);
    },
    queryPay(auto) {
      this.auto = auto;
      if (this.payType === "MWEB") {
        this.queryWxH5();
      } else if (this.payType === "JSAPI") {
        this.queryWxJsapi()
      } else {
        this.queryAlipay();
      }
    },
    queryAlipay() {
      let param = {
        orderNo: this.orderNo
      };
      client.post("/api/h5/pay/alipay/query", param).then(res => {
        console.log(res)
        this.payResult(res.data);
      })
    },
    queryWxH5() {
      let param = {
        orderNo: this.orderNo
      };
      client.post("/api/h5/pay/wechat/query", param).then(res => {
        console.log(res)
        this.payResult(res.data);
      })
    },
    queryWxJsapi() {
      let param = {
        orderNo: this.orderNo
      };
      client.post("/api/h5/pay/wechat/jsapi/query", param).then(res => {
        console.log(res)
        this.payResult(res.data);
      })
    },
    payResult(data) {
      if (data.paySuccess) {
        if (data.orderType === "PASS_CARD_COST") {
          this.$router.replace({
            path: '/payResult', query: {
              phoneNum: data.phoneNum,
              passCardType: data.passCardType,
              id: data.id
            }
          });
        } else if (data.orderType === "SPORADIC_CHARGE") {
          this.$router.replace({path: '/scanVerify/chargeResult', query: {phoneNum: data.phoneNum}});
        }
      } else {
        if (this.auto) return;
        this.$router.replace({
          path: '/scanVerify/chargePay', query: {
            orderNo: this.orderNo,
            orderAmount: this.orderAmount
          }
        });
      }
    },

  },
}
</script>

<style scoped>
.vg-content {
  margin: 15px;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  align-items: center;
}

.logo {
  align-self: flex-start;
}

.text {
  margin-top: 10px;
  color: #101010;
  font-size: 20px;
  font-weight: bold;
}

</style>
